import styled, { css } from 'styled-components';

type FormErrorMessageProps = {
  //   className: string;
  //   name: string;
  hasError: boolean;
  theme: any;
  className?: string;
  children?: React.ReactNode;
  errorMessage?: string;
  label?: string;
};
// const FormError = ({ className, children, errors }: FormErrorMessageProps) => (
//   // <ErrorMessage className={className}>{children} />
//   <ErrorMessage
//     errors={errors}
//     name="courseName"
//     render={({ message }) => <p>{message}</p>}
//   />
// );
// // works
// const FormErrorMessageP = styled.p(
//   ({ theme }) => `
//       color: ${theme.colors.error};
//     `
// );
// // doesn't work
// const FormErrorMessage2 = styled(ErrorMessage).attrs({ color: 'red' })`
//   background-color: yello;
// `;
// const StyledError = styled(ErrorMessage)`
//   color: red;
//   margin-top: 0;
// `;
// (
//   ({ theme }) => `
//       color: ${theme.colors.error};
//     `
// );
const orange = css`
  color: 'orange';
`;
// const yellow = css`
//   color: ${(props) => props.theme.colors.highlight};
// `;
// const FormErrorMessage2 = styled(ErrorMessage)`
//   /* color: 'yellow'; */
//   ${(props) => {
//     if (props.errors || props.message) {
//       return orange;
//     }
//     return yellow;
//   }};
// `;
const FormError = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.error};
    padding: 8px 8px 8px 0;
    display: block;
  `
);

// const FormInput2 = ({ className, children, hasError }: FormErrorMessageProps) =>
//   // <ErrorMessage className={className}>{children} />
//   styled.input(
//     ({ theme }) => `
//     background: ${theme.colors.grey};
//     border: 1px solid ${theme.colors.border};
//     width: 100px;
//     height: 50px;
//     padding: 0 15px;
//     color: ${theme.colors.main};
//     font-weight: 400;
//     font-size: 0.94em;
//     ${(hasError: any) => {
//       if (hasError) {
//         return orange;
//       }
//     }}
//     `
//   );
// const InputError = css<{ theme: ThemeProps<unknown> }>`
const InputError = css`
  outline: 1px solid red;

  &:before {
    color: red;
    background: ${({ theme }) => theme.colors.error};
    content: '* InputError 90';
  }

  /* background: ${({ theme }) => 'red'}; */
  /* background: ${({ theme }) => theme.colors.error}; */
  /* color: 'red'; */
`;

const FormInput = styled.input<FormErrorMessageProps>(
  ({ theme, hasError }) => `
  background: ${theme.colors.background};
  border: 1px solid ${theme.colors.border};
  border-radius: 4px;
  height: 32px;
  padding: 0 16px;
  margin: 8px;
  color: ${theme.colors.main};
  font-weight: 400;
  font-size: 16px;
  outline: 1px solid ${hasError ? theme.colors.error : theme.colors.main};
  ::placeholder {
    color: ${theme.colors.main};
  }
  `
);

const Message = styled.span<FormErrorMessageProps>(
  ({ theme, hasError }: FormErrorMessageProps) => `
        // color: ${hasError ? theme.colors.error : theme.colors.main};
        margin-left: ${theme.margins.default};
        margin-bottom: -4px;
        height: 16px;
    `
);
const Foo = ({
  className,
  children,
  hasError,
  label,
  errorMessage
}: FormErrorMessageProps) => (
  <div className={className}>
    <Message
      className="err-message"
      hasError
      label={label}
      errorMessage={errorMessage}
    >
      {hasError ? errorMessage : label}
    </Message>
    {children}
  </div>
);
const InputWrapper = styled(Foo)<FormErrorMessageProps>(
  ({ theme, hasError, errorMessage, label }) => `
  display: flex;
  flex: 1;
  color: ${hasError ? theme.colors.error : theme.colors.label};
  // margin: 8px;
  font-size: ${theme.fonts.formError};
  width: 80%;
  flex-direction: column;
  margin: auto;
  
  ${
    hasError ? (
      <Message
        className="Message"
        children={errorMessage}
        hasError={hasError}
      />
    ) : (
      <Message className="Message" children={label} hasError={hasError} />
    )
  }
`
);

const FormSubmit = styled(FormInput)(
  ({ theme }) => css`
    background-color: ${theme.colors.ctaButton};
    // type="submit"
  `
);

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
export { FormError, FormInput, FormSubmit, InputWrapper, Form };
